import { StepsGuide } from './StepsGuide'

export const StepsGuideContainer = StepsGuide
